// extracted by mini-css-extract-plugin
export default {"card":"Z_-z"};